import React, { useState, useEffect } from 'react';
import {
  formatDateMonth,
  KTSVG,
  toAbsoluteUrl,
  formatPhoneNumber,
  formatPrice,
  formatPriceSimple,
} from '../../../../../_mexablock/helpers';
import { Filter } from './Filter';
import Select, { MultiValue } from 'react-select';
import {
  getProviderById,
  getProtectedImageUrl,
} from '../../../../service/inventario/productos';
import { CreateModal } from '../_modals/CreateModal';
import { UpdateModal } from '../_modals/UpdateModal';

type Props = {
  className: string;
  dataInventario: any;
  onCleanFilter: (updateGrid: boolean) => void;
  onSearchFilter: (values: any) => void;
  descripcion: string;
  costo: string;
  proveedor: number;
  cantidad: string;
  tipo_stock: string;
  disponible: string;
  image: string;
  id_package: number;
};

const TablePackage: React.FC<Props> = ({
  className,
  dataInventario,
  onSearchFilter,
  onCleanFilter,
  descripcion,
  costo,
  proveedor,
  cantidad,
  tipo_stock,
  disponible,
  image,
  id_package,
}) => {
  type YearOption = { value: number; label: string };
  const [proveedorName, setProveedorName] = useState<string>('');
  const [selectedOption, setSelectedOption] = useState<MultiValue<YearOption>>(
    []
  );
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [visivilityModal, setVisivilityModal] = useState<boolean>(false);
  const [visivilityEditModal, setVisivilityEditModal] =
    useState<boolean>(false);
  const [initFilterValues, setInitFilterValues] = useState({
    status_id: 0,
    user_id: '',
    init_date: '',
    end_date: '',
    filter: 0,
  });

  const statusOptions = [
    { value: 7, label: 'Activada' },
    { value: 8, label: 'Portada' },
    { value: 9, label: 'Disponible' },
    { value: 11, label: 'Asignada' },
    { value: 10, label: 'Enviada' },
    { value: 16, label: 'Suspendida' },
    { value: 17, label: 'Cancelada' },
  ];

  const statusColors: Record<number, string> = {
    7: '#773ADA33',
    8: '#FFC70033',
    9: '#50CD8933',
    10: '#009EF733',
    11: '#7E829933',
    16: '#F1416C33',
    17: '#D9214E33',
  };

  const [src, setSrc] = useState<string>('');

  useEffect(() => {
    const loadImage = async () => {
      if (!image) {
        setSrc(toAbsoluteUrl('/media/avatars/Vector.png'));
        return;
      }

      const url = await getProtectedImageUrl(image);
      setSrc(url || toAbsoluteUrl('/media/avatars/Vector.png'));
    };

    loadImage();
  }, [image]);

  const handleCustomerChange = (selected: MultiValue<YearOption>) => {
    setSelectedOption(selected);
  };

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      status_id: 0,
      user_id: '',
      init_date: '',
      end_date: '',
      filter: 0,
    });
  };

  const fetchPost = async () => {
    const filters = { id: proveedor };

    try {
      const sends = await getProviderById(filters);
      if (sends) {
        setProveedorName(sends[0].name);
      }
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  const statusEnvio = (id: number, name: string) => {
    switch (id) {
      case 9:
        return (
          <span className="fs-7 fw-semibold badge badge-light-success text-center d-inline-block">
            {name}
          </span>
        );
      case 10:
        return (
          <span className="fs-7 fw-semibold badge badge-light-primary text-center d-inline-block">
            {name}
          </span>
        );
      case 7:
        return (
          <span className="fs-7 fw-semibold badge badge-light-info text-center d-inline-block">
            {name}
          </span>
        );

      case 8:
        return (
          <span className="fs-7 fw-semibold badge badge-light-warning text-center d-inline-block">
            {name}
          </span>
        );
      case 11:
        return (
          <span className="fs-7 fw-semibold badge badge-light-dark text-center d-inline-block">
            {name}
          </span>
        );
      case 16:
        return (
          <span className="fs-7 fw-semibold badge badge-light-danger text-center d-inline-block">
            {name}
          </span>
        );
      case 17:
        return (
          <span className="fs-7 fw-semibold badge badge-light-danger text-center d-inline-block">
            {name}
          </span>
        );
    }
  };

  const addRegister = () => {
    setVisivilityModal(!visivilityModal);
  };

  const editRegister = () => {
    setVisivilityEditModal(!visivilityEditModal);
  };
  useEffect(() => {
    fetchPost();
  }, [proveedor]);

  useEffect(() => {
    onSearchFilter(initFilterValues);
  }, [initFilterValues]);

  useEffect(() => {
    onCleanFilter(true);
  }, [reloadGrid]);

  useEffect(() => {
    const statusIds = selectedOption.map((opt) => opt.value).join(',');
    setInitFilterValues((prev: any) => ({
      ...prev,
      status_id: statusIds,
    }));
  }, [selectedOption]);

  return (
    <>
      <div className={`card ${className}`}>
        <div className="card-header border-0 pt-5">
          <div className="row">
            <div className="col">
              <div className="position-relative">
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={handleFilterClean}
                  onSearchFilter={handleFilter}
                />
              </div>
            </div>
            <div className="col">
              <Select
                options={statusOptions}
                placeholder={'Estatus'}
                onChange={handleCustomerChange}
                value={selectedOption}
                isMulti
                noOptionsMessage={() => <span>No hay registros</span>}
                menuPortalTarget={document.body}
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: '#181c32',
                  }),
                  indicatorSeparator: (provided, state) => ({
                    ...provided,
                    display: 'none',
                  }),
                  dropdownIndicator: (provided, state) => ({
                    ...provided,
                    color: '#7E8199',
                  }),
                  control: (provided, state) => ({
                    ...provided,
                    width: '200px',
                    border: '1px solid #e4e6ef',
                    marginTop: '5px',
                    borderRadius: '6px',
                    boxShadow: 'none',
                    backgroundColor: state.isDisabled ? '#EFF2F5' : 'white',
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    maxHeight: '30px',
                    overflowY: 'auto',
                    paddingBottom: 0,
                  }),
                  option: (provided, state) => {
                    const bgColor = statusColors[state.data.value] || 'white';
                    const isSelected = state.isSelected;

                    return {
                      ...provided,
                      backgroundColor: isSelected
                        ? bgColor.replace('33', '')
                        : bgColor,
                      color: isSelected ? 'white' : '#181C32',
                      fontWeight: isSelected ? 600 : 400,
                      fontSize: '1.1rem',
                      cursor: 'pointer',
                    };
                  },

                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),

                  multiValue: (styles, { data }) => {
                    const color = statusColors[data.value] || '#EFF2F5';
                    return {
                      ...styles,
                      backgroundColor: color,
                      borderRadius: '4px',
                    };
                  },
                  multiValueLabel: (styles) => ({
                    ...styles,
                    color: '#181C32',
                    fontWeight: 500,
                  }),
                  multiValueRemove: (styles) => ({
                    ...styles,
                    color: '#7E8299',
                    ':hover': {
                      backgroundColor: '#E4E6EF',
                      color: '#000',
                    },
                  }),
                }}
              />
            </div>
          </div>

          <div className="card-toolbar">
            <a className="btn btn-sm btn-light-primary" onClick={addRegister}>
              <KTSVG
                path="/media/icons/duotune/arrows/arr075.svg"
                className="svg-icon-5 svg-icon-gray-500 me-1"
              />
              Agregar Producto
            </a>
          </div>
        </div>
        {Number(cantidad) > 0 && (
          <>
            <div className="row mt-5 border pt-5 pb-5">
              <div className="col-2 d-flex justify-content-center align-items-center">
                <div className="symbol symbol-100px me-5 border">
                  <img
                    src={src}
                    crossOrigin="anonymous"
                    alt="paquete_tabla"
                    className="bg-secondary "
                  />
                </div>
              </div>
              <div className="col-7">
                <div className="row">
                  <div className="col text-start d-flex flex-column">
                    <span className="fw-bolder fs-6">{tipo_stock}</span>
                    <span className="fs-7 fw-bolder">
                      {disponible} / {cantidad} pza
                    </span>
                  </div>
                  <div className="col text-end d-flex flex-column">
                    <span className="fw-normal fs-6">{proveedorName}</span>
                    <span className="fs-7 fw-bolder">
                      {costo != null
                        ? formatPrice(Number(costo), 'es-MX', 'MXN', 2, 2)
                        : ''}
                    </span>
                  </div>
                  <span className="fs-7">{descripcion}</span>
                </div>
              </div>
              <div className="col-3 text-center">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={editRegister}
                >
                  Editar
                  <KTSVG
                    path="/media/icons/duotune/general/gen055.svg"
                    className="svg-icon-5 ms-2"
                  />
                </button>
              </div>
            </div>
            <div className="card-body py-3">
              <div
                className="table-responsive"
                style={{ maxHeight: '500px', overflowY: 'auto' }}
              >
                <table className="table align-middle gs-0 gy-4">
                  <thead
                    style={{
                      position: 'sticky',
                      top: 0,
                      background: '#f9f9f9',
                      zIndex: 2,
                    }}
                  >
                    <tr className="fw-bold text-muted bg-light">
                      <th className="ps-4 min-w-200px rounded-start">ICCID</th>
                      <th className="min-w-125px">MSISDN</th>
                      <th className="min-w-125px">Precio</th>
                      <th className="min-w-125px">Fecha Salida</th>
                      <th className="min-w-125px">Estatus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataInventario?.map((item: any, index: any) => (
                      <tr key={index}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                              <span className="text-gray-900 fw-bold text-hover-primary mb-1 fs-6">
                                {item.iccid}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className="text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6">
                            {formatPhoneNumber(item.msisdn)}
                          </span>
                        </td>
                        <td>
                          <a className="text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6">
                            {item.output_price
                              ? `$${formatPriceSimple(item.output_price)}`
                              : ''}
                          </a>
                        </td>
                        <td>
                          <span className="text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6">
                            {item.status_id === 9 || !item.departure_date
                              ? 'Sin salida'
                              : formatDateMonth(item.departure_date)}
                          </span>
                        </td>
                        <td>{statusEnvio(item.status.id, item.status.name)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
      <CreateModal
        show={visivilityModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModal(!visivilityModal);
        }}
      ></CreateModal>
      <UpdateModal
        idPackage={id_package}
        show={visivilityEditModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityEditModal(!visivilityEditModal);
        }}
      />
    </>
  );
};

export { TablePackage };
